import React from 'react';
import { Link } from 'react-router-dom';

const resources = [
  {
    title: 'White Papers',
    path: '/whitepapers',
    desc: 'In-depth technical papers covering NaaS Cloud architecture, industry-specific deployment guides, and best practices for enterprise WiFi.'
  },
  {
    title: 'Knowledge Center',
    path: '/knowledgecenter',
    desc: 'Technical documentation, FAQs, deployment guides, and troubleshooting resources for Sarvanta products.'
  },
  {
    title: 'Blog',
    path: '/blogs',
    desc: 'Industry insights, product updates, customer stories, and thought leadership from the Sarvanta team.'
  }
];

const Resources = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '60px 40px' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Resources</h1>
        <p style={{ color: '#a0aec0', fontSize: '1.1rem', marginBottom: '50px', lineHeight: '1.7' }}>
          Technical resources, white papers, and insights to help you make informed decisions
          about your network infrastructure.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {resources.map((resource, i) => (
            <Link key={i} to={resource.path} style={{
              padding: '32px', backgroundColor: '#0a1628', borderRadius: '12px',
              border: '1px solid #1a2744', textDecoration: 'none', color: '#fff',
              display: 'block'
            }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '12px', color: '#60a5fa' }}>{resource.title}</h2>
              <p style={{ color: '#a0aec0', lineHeight: '1.7', margin: 0 }}>{resource.desc}</p>
              <span style={{ color: '#2563eb', marginTop: '16px', display: 'inline-block', fontWeight: '600' }}>
                Explore &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Resources;
